import React, {
  ReactElement,
  useEffect,
  useState,
  useCallback,
  useMemo,
} from 'react';
import {
  Button as MUIButton,
  IconButton,
  Stack,
  Switch,
  Table,
  TableContainer,
} from '@mui/material';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { MoreOptions } from '../Table/assets/MoreOptions';
import { toaster } from '../../services/toaster';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import { contact } from '../../schema/contact';
import { SlidingPaneEdit } from '../Page/SlidingPaneEdit';
import Tooltip from '@mui/material/Tooltip';
import AddIcon from '@mui/icons-material/Add';
import { serviceProviderContact } from '../../schema/serviceProviderContact';
import api from '../../services/api';
import TableBody from '@mui/material/TableBody';
import { AddNewContact } from '../SalesPartner/AddNewContactForm';
import { salesPartnerContact } from '../../schema/salesPartnerContact';
import { datagridColors } from '../../assets/datagridStyles';
import {
  DataGridPro,
  GridColDef,
  GridFilterModel,
  GridFooter,
  GridPaginationModel,
  GridSortModel,
} from '@mui/x-data-grid-pro';
import Box from '@mui/material/Box';
import { useGridApiRef } from '@mui/x-data-grid';
import ArrowDropUpRoundedIcon from '@mui/icons-material/ArrowDropUpRounded';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';

export const ActivityVisibilityTable = ({
  schema,
  values,
  tableType,
}: {
  schema: any;
  values: any;
  tableType: string;
}): ReactElement => {
  const [activities, setActivities] = useState<any>([]);
  const [loading, setLoading] = useState<any>(false);
  const apiRef = useGridApiRef();

  const fetchActivities = useCallback(() => {
    setLoading(true);
    api
      .get(`/sales-partners/${values.id}/visible-activities`)
      .then((res: any) => {
        setActivities(res);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    fetchActivities();
  }, [values, schema]);

  const handleChangeShowActivity = (id: any, checked: any) => {
    setActivities((prevActivities: any) =>
      prevActivities.map((activity: any) =>
        activity.activity_id === id
          ? { ...activity, show: checked ? 1 : 0 }
          : activity
      )
    );

    if (checked) {
      api
        .post(`/sales-partners/${values.id}/visible-activities/create`, {
          activity_id: id,
        })
        .then((res: any) => {});
    } else {
      api
        .delete(`/sales-partners/${values.id}/visible-activities/${id}`, {})
        .then((res: any) => {});
    }
  };
  const handleChangeShowPrices = (id: any, checked: any) => {

    setActivities((prevActivities: any) =>
      prevActivities.map((activity: any) =>
        activity.activity_id === id
          ? { ...activity, show_prices: checked ? 1 : 0 }
          : activity
      )
    );

    api
      .post(`/sales-partners/${values.id}/visible-activities/${id}`, {
        show_prices: checked,
      })
      .then((res: any) => {});
  };

  const [filterModelStatic, setFilterModelStatic] = useState<GridFilterModel>({
    items: [],
  });
  const [sortModelStatic, setSortModelStatic] = useState<GridSortModel>([]);
  const [paginationModelStatic, setPaginationModelStatic] = useState<
    GridPaginationModel
  >({
    page: 0,
    pageSize: 10,
  });

  const columns: GridColDef[] = useMemo(() => {
    const columnArray: GridColDef[] = [
      {
        field: 'actions',
        type: 'string',
        headerName: '',
        cellClassName: '',
        editable: false,
        width: 50,
        renderCell: (params: any) => {
          const currentPage = paginationModelStatic.page;
          const pageSize = paginationModelStatic.pageSize;

          const rowIndex =
            currentPage * pageSize +
            params.api.getRowIndexRelativeToVisibleRows(params.id) +
            1;

          const id = params.id;
          return <>{rowIndex}</>;
        },
        renderHeaderFilter: () => {
          return <></>;
        },
      },
      {
        field: 'activity',
        headerName: 'Activity',
        editable: false,
        type: 'string',
        minWidth: 125,
        flex: 1,
        valueGetter: (props: any) => props.value?.name,
        renderCell: (props: any) => props.value,
      },
      {
        field: 'show',
        headerName: 'Show Activity',
        editable: false,
        align: 'center',
        type: 'string',
        width: 120,
        renderCell: (props: any) => {
          return (
            <Switch
              checked={props?.value}
              onChange={(event: any, checked: any) => {
                handleChangeShowActivity(props?.id, checked);
              }}
            />
          );
        },
      },
      {
        field: 'show_prices',
        headerName: 'Show Prices',
        editable: false,
        align: 'center',
        type: 'string',
        width: 120,
        renderCell: (props: any) => {
          return (
            <Switch
              disabled={!props.row?.show}
              checked={props?.value}
              onChange={(event: any, checked: any) => {
                handleChangeShowPrices(props?.id, checked);
              }}
            />
          );
        },
      },
    ];

    return columnArray;
  }, [
    activities,
    sortModelStatic,
    filterModelStatic,
    paginationModelStatic,
    apiRef,
  ]);

  function CustomSortIcon(props: any) {
    return (
      <div
        style={{
          background: '#42948c',
          borderRadius: '40px',
          height: '15px',
          width: '15px',
        }}
      >
        <ArrowDropUpRoundedIcon
          color={'secondary'}
          sx={{
            width: '15px',
            height: '15px',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        />
      </div>
    );
  }

  function CustomSortIconAsc(props: any) {
    return (
      <div
        style={{
          background: '#42948c',
          borderRadius: '40px',
          height: '15px',
          width: '15px',
        }}
      >
        <ArrowDropUpRoundedIcon
          color={'secondary'}
          sx={{
            width: '15px',
            height: '15px',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        />
      </div>
    );
  }

  const CustomFooter = () => {
    return (
      <Stack
        direction={'row'}
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0 8px',
        }}
      >
        <IconButton
          sx={{
            visibility: 'hidden',
          }}
          onClick={() => {}}
        >
          <AddIcon color={'primary'} />
        </IconButton>

        <GridFooter />
      </Stack>
    );
  };

  function CustomSortIconDesc(props: any) {
    return (
      <div
        style={{
          background: '#42948c',
          borderRadius: '40px',
          height: '15px',
          width: '15px',
        }}
      >
        <ArrowDropDownRoundedIcon
          color={'secondary'}
          sx={{
            width: '15px',
            height: '15px',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        />
      </div>
    );
  }

  const handleFilterModelChange = useCallback((newModel: any) => {
    setFilterModelStatic((prevModel) =>
      JSON.stringify(prevModel) === JSON.stringify(newModel)
        ? prevModel
        : newModel
    );
  }, []);

  const handleSortModelChange = useCallback((newModel: any) => {
    setSortModelStatic((prevModel) =>
      JSON.stringify(prevModel) === JSON.stringify(newModel)
        ? prevModel
        : newModel
    );
  }, []);

  const handlePaginationModelChange = useCallback((newModel: any) => {
    setPaginationModelStatic((prevModel) =>
      JSON.stringify(prevModel) === JSON.stringify(newModel)
        ? prevModel
        : newModel
    );
  }, []);

  return (
    <Box
    sx={{
      width: '100%'
    }}>
      <Box sx={datagridColors('400px')}>
        <DataGridPro
          apiRef={apiRef}
          rows={activities}
          getRowClassName={(params: any) => {
            const color =
              params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd';
            return `${color}`;
          }}
          disableColumnMenu={true}
          columns={columns}
          loading={loading}
          getRowHeight={() => 30}
          disableRowSelectionOnClick
          columnHeaderHeight={38}
          rowHeight={38}
          pagination
          slots={{
            // @ts-ignore
            columnSortedDescendingIcon: CustomSortIconDesc,
            columnSortedAscendingIcon: CustomSortIconAsc,
            columnUnsortedIcon: CustomSortIcon,
            footer: CustomFooter,
            headerFilterMenu: null,
          }}
          unstable_headerFilters={true}
          pageSizeOptions={[25, 50, 100]}
          initialState={{
            pinnedColumns: { left: ['actions', 'activity_name'], right: [] },
          }}
          filterMode={'client'}
          disableChildrenFiltering={true}
          onFilterModelChange={handleFilterModelChange}
          sortingMode={'client'}
          onSortModelChange={handleSortModelChange}
          disableMultipleColumnsSorting={false}
          onPaginationModelChange={handlePaginationModelChange}
        />
      </Box>
    </Box>
  );
};
